import { FunctionComponent } from "react";

import AppLogo from "@/assets/images/favicon.png";
import { classNames } from "@/utils/classNames";
import { Spinner } from "@/components/Spinner/Spinner";

/**
 * A wizard step that is not ready to be shown yet.
 *
 * Both steps that prefill themselves from the user's targeting wait behind this
 * rather than rendering an empty version of themselves first. Seeding a step after
 * it is on screen swapped the featured list types and every prefilled field under
 * the user (PREC-3719), and on the Track step an empty filter rail beside a loading
 * table read as searching with no criteria at all — in both cases the step looked
 * like it was reloading itself a few seconds in.
 *
 * So the rule for these steps is: show nothing until it can be shown filled.
 */
export const OnboardingStepLoading: FunctionComponent<{
	title: string;
	subtitle: string;
	/** Width of the step this is standing in for, so revealing it does not resize. */
	widthClass?: string;
}> = ({ title, subtitle, widthClass = "w-[760px]" }) => (
	<div className="w-full flex flex-col items-center justify-center">
		<div
			className={classNames(
				"flex max-w-[100%] flex-col items-center rounded-[20px] bg-white px-8 py-16 shadow-[0px_0px_80px_0px_rgba(171,178,217,0.35)]",
				widthClass
			)}
		>
			<img alt="logo" className="mb-5 h-10 w-10" src={AppLogo} />
			<Spinner color="#4D66F5" />
			<div className="mt-5 text-center text-md font-bold">{title}</div>
			<div className="mt-1 text-center text-ssm text-text-meta">{subtitle}</div>
		</div>
	</div>
);
